// extracted by mini-css-extract-plugin
export default {"cardContainer":"card_cardContainer__FIP5C","imageContainer":"card_imageContainer__b-UOr","detailContainer":"card_detailContainer__MUzWv","addBtn":"card_addBtn__3qUEb"};